import { Component, type ReactNode } from 'react';

/** Unmount the failed app (including its audio/socket cleanup) and offer recovery. */
export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="app"><main id="main" className="service-error" role="alert">
      <h1>Something interrupted Telx.</h1>
      <p>Reload to continue. If you were in a call, you can rejoin from this page.</p>
      <button className="button button-primary" onClick={() => window.location.reload()}>Reload Telx</button>
      <a className="text-button" href="/app">Back to calls</a>
    </main></div>;
  }
}
